import { CheckoutComPaymentResult } from '@daymade/common-lib/dbEnums';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const authCheckoutComContract = c.router(
  {
    getPaymentStatus: {
      method: 'GET',
      path: '/payment-session/status',
      query: z.object({
        checkoutComPaymentSessionId: z.string(),
      }),
      responses: {
        200: z.object({
          status: z.nativeEnum(CheckoutComPaymentResult).nullable(),
        }),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  },
);
